import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import formStore from './modules/form/index'
import popupStore from './modules/popup/index'
import { parsePath } from '../utils'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  helpy: {},
  notifications: [],
  modal: {
    modals: [],
    openModals: [],
    globalSearch: '',
  },
  sidebarPosition: 'left',
  enabledFunctions: [],
  Queries: {},
}

const getters = {
  notifications: (state) => state.notifications,
  helpy: (state) => state.helpy,
  openModals: (state) => state.modal.modals.filter(({ isOpen }) => isOpen),
  isModalOpen: (state) => (id) => {
    const modal = state.modal.modals.find((modal) => id === modal.id)
    return modal && modal.isOpen
  },
  isModalVisible: (state) => (id) => state.modal.openModals.indexOf(id) === state.modal.openModals.length - 1,
  modals: (state) => state.modal.modals,
  modalParams: (state) => (id) => {
    const modal = state.modal.modals.find((modal) => id == modal.id)
    return modal ? modal.modalParams : {}
  },
  sidebarPosition: (state) => state.sidebarPosition,
  globalSearch: (state) => state.modal.globalSearch,
  enabledFunctions: (state) => state.enabledFunctions,
  Queries: (state) => state.Queries,
}

const actions = {
  notify({ commit, state }, notification) {
    notification.id = notification.id || Date.now()
    commit(types.ADD_NOTIFICATION, { notification })
    if (notification.timeout) {
      notification.timeoutId = setTimeout(() => {
        commit(types.REMOVE_NOTIFICATION, { id: notification.id })
      }, notification.timeout)
    }
    return notification
  },
  updateNotification({ commit, state }, notification) {
    // TODO: re-add if needed
    commit(types.UPDATE_NOTIFICATION, { notification })
  },
  addModal({ commit, state }, { id, isOpen = false }) {
    id = id || Date.now()
    commit(types.ADD_MODAL, { id, isOpen })
  },
  showModal({ commit, state }, { id, params }) {
    if (!id) {
      return
    }
    commit(types.TOGGLE_MODAL, { id, isOpen: true, modalParams: params })
  },
  hideModal({ commit, state }, id) {
    if (!id) {
      return
    }
    commit(types.TOGGLE_MODAL, { id, isOpen: false })
  },
  removeModal({ commit, state }, id) {
    if (!id) {
      return
    }
    commit(types.REMOVE_MODAL, { id })
  },
  setForceUpdate({ commit, state }) {
    commit(types.SET_FORCE_UPDATE)
  },
  setGlobalSearch({ commit }, value) {
    commit(types.SET_GLOBAL_SEARCH, value)
  },
  loadHelpy({ commit, state }, helpy) {
    commit(types.LOAD_HELPY, { helpy })
  },
  setEnabledFunctions({ commit, state }, functions) {
    commit(types.SET_ENABLED_FUNCTIONS, functions)
  },
  setFieldByNamespaceAndPath({ commit, state, dispatch }, { namespace, path, prop, value }) {
    dispatch(`${namespace}/updatePropByPath`, { path, prop, value })
  },
}

const mutations = {
  [types.ADD_NOTIFICATION](state, { notification }) {
    state.notifications.push(notification)
  },
  [types.REMOVE_NOTIFICATION](state, { id }) {
    let index = state.notifications.findIndex((item) => item.id === id)
    state.notifications.splice(index, 1)
  },
  [types.UPDATE_NOTIFICATION](state, { notification }) {
    let index = state.notifications.findIndex((item) => item.id === notification.id)
    if (index === -1) {
      return
    }
    let item = Object.assign({}, state.notifications[index], notification)
    state.notifications.splice(index, 1, item)
  },
  [types.LOAD_HELPY](state, { helpy }) {
    state.helpy = helpy
  },
  [types.ADD_MODAL](state, modal) {
    const index = state.modal.modals.map((x) => x.id).indexOf(modal.id)
    if (index !== -1) {
      state.modal.modals.splice(index, 1, modal)
    } else {
      state.modal.modals.push(modal)
    }
  },
  [types.TOGGLE_MODAL](state, { id, isOpen, modalParams = {} }) {
    let index = state.modal.modals.findIndex((modal) => id === modal.id)
    if (index === -1) {
      return
    }
    state.modal.modals[index].modalParams = modalParams
    let item = Object.assign({}, state.modal.modals[index], { isOpen })
    state.modal.modals.splice(index, 1, item)
    if (isOpen) {
      state.modal.openModals.push(id)
    } else {
      state.modal.openModals.pop()
      const lastIndex = state.popup.popups.length - 1
      if (lastIndex >= 0) {
        state.popup.popups[lastIndex].isOpened = false
      }
    }
    //document.body.classList[state.modal.openModals.length ? 'add' : 'remove']('modal-open')
  },
  [types.REMOVE_MODAL](state, { id }) {
    let index = state.modal.modals.findIndex((modal) => id === modal.id)
    if (index === -1) {
      return
    }
    state.modal.modals.splice(index, 1)
  },
  [types.SET_FORCE_UPDATE](state) {},
  [types.SET_SIDEBAR_POSITION](state, position) {
    state.sidebarPosition = position
  },
  [types.SET_GLOBAL_SEARCH](state, value) {
    state.modal.globalSearch = value
  },
  [types.SET_ENABLED_FUNCTIONS](state, functions) {
    state.enabledFunctions = functions
  },
  [types.SET_FIELD_BY_NAMESPACE_AND_PATH](state, { namespace, path, value }) {
    let [pageId, groupId, rowId, fieldId] = parsePath(path)
    const field = state[namespace].form.pages[pageId].groups[groupId].rows[rowId][fieldId]
    Vue.set(field, 'value', value)
  },
}
export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    mapStore: {
      state: {},
    },
    formStore,
    popup: popupStore,
  },
  strict: debug,
})
